// Globals
import React from 'react';
import { PaginationProps as AntPaginationProps } from 'antd';
import { useTranslation } from 'react-i18next';

// Components
import { StyledPagination, StyledPaginationWrap } from './PaginationStyles';

export type PaginationProps = AntPaginationProps;

const Pagination = ({ onChange, ...props }: PaginationProps) => {
  const { t } = useTranslation(['common']);
  return (
    <StyledPaginationWrap>
      <StyledPagination
        locale={{
          next_page: t('next_page'),
          prev_page: t('prev_page'),
          items_per_page: t('items_per_page'),
        }}
        showSizeChanger={false}
        showLessItems
        onChange={onChange}
        {...props}
      />
    </StyledPaginationWrap>
  );
};

export default Pagination;
